<template>
  <section class="my-16">
    <v-container>
      <v-row no-gutters>
        <!-- IMAGEM -->
        <v-col
          cols="12"
          sm="6"
          v-if="section.imageSrc && section.leftImage !== undefined"
          class="text-center order-1"
          :class="{
            'order-sm-0': section.leftImage === true,
            'order-sm-1': section.leftImage === false
          }"
        >
          <div class="d-flex justify-center align-center full-parent">
            <vue-aos
              animation-class="animate__animated"
              :class="{
                animate__zoomInLeft: section.leftImage === true,
                animate__zoomInRight: section.leftImage === false
              }"
            >
              <v-img contain max-height="300" :src="section.imageSrc" />
            </vue-aos>
          </div>
        </v-col>

        <!-- CONTEÚDO -->
        <v-col
          cols="12"
          :sm="section.imageSrc && section.leftImage !== undefined ? 6 : 12"
          class="pa-8 grey--text text--darken-1 order-0"
          :class="[
            {
              'order-sm-1': section.leftImage === true,
              'order-sm-0': section.leftImage === false
            },
            {
              'd-flex justify-center align-center text-center': !section.imageSrc || section.leftImage === undefined
            }
          ]"
        >
          <div class="d-flex justify-center align-md-start align-center">
            <div>
              <vue-aos
                animation-class="animate__animated"
                :class="{
                  animate__zoomInRight: section.leftImage === true,
                  animate__zoomInLeft: section.leftImage === false
                }"
              >
                <h2 class="text-h4 mb-8 black--text" v-text="section.title"></h2>
              </vue-aos>

              <div
                animation-class="animate__animated"
                :class="{
                  animate__zoomInRight: section.leftImage === true,
                  animate__zoomInLeft: section.leftImage === false
                }"
              >
                <div v-html="$sanitize(section.content)" style="word-break: break-word; white-space: normal;"></div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- BOTÕES -->
      <v-col cols="12" v-if="section.buttons && section.buttons.length">
        <div class="d-flex justify-center flex-wrap">
          <v-btn
            v-for="(btn, i) in section.buttons"
            :key="i"
            :href="btn.link"
            target="_blank"
            color="primary"
            class="mx-2 my-1"
            rounded
            depressed
          >
            {{ btn.text }}
          </v-btn>
        </div>
      </v-col>
    </v-container>
  </section>
</template>

<script>
import VueAos from "vue-aos";

export function Footer(options = { visible: true }) {
  const tipo = "rodape";
  Object.defineProperty(this, "type", { get: () => tipo });

  this.visible = options.visible;

  this.stringify = function () {
    return JSON.stringify({ ...this, type: tipo });
  };
  this.toApi = function () {
    return {
      tipo: tipo,
      indicadorSecao: tipo,
      visible: this.visible
    };
  };
}

export function Section(options = {
  menuTitle: "Menu",
  imageSrc: "/img/professora-ensinando.png",
  title: "Título",
  content: `Conteúdo`,
  leftImage: true,
  buttons: []
}) {
  Object.defineProperty(this, "type", { get: () => "regular" });

  this.menuTitle = options.menu || options.menuTitle;
  this.imageSrc = options.enderecoDaImagem || options.imageSrc;
  this.title = options.titulo || options.title;
  this.content = options.conteudo || options.content;
  this.leftImage =
    typeof options.imagemNoLadoEsquerdo !== "undefined"
      ? options.imagemNoLadoEsquerdo
      : options.leftImage;

  this.buttons = options.botoes || options.buttons || [];

  this.isValid = function () {
    return this.imageSrc || this.title || this.content;
  };

  this.stringify = function () {
    return JSON.stringify({ ...this, type: "regular" });
  };

  this.toApi = function () {
    return {
      menu: this.menuTitle,
      enderecoDaImagem: this.imageSrc,
      titulo: this.title,
      conteudo: this.content,
      imagemNoLadoEsquerdo: this.leftImage,
      botoes: this.buttons,
      tipo: "regular"
    };
  };

  if (!this.isValid()) {
    throw new Error("Seção de conteúdo inválida.");
  }
}

export default {
  name: "LandingPageSection",
  components: { VueAos },
  props: {
    preview: {
      type: Boolean,
      required: false
    },
    section: {
      type: Section,
      required: true,
      validator(value) {
        return value.isValid();
      }
    }
  }
};
</script>
